import * as React from "react";
import { useParams } from "react-router-dom";
import ApartmentForm from "../../components/Forms/Apartment/FlowForm/FlowForm";

export default function CreateApartment() {
  const { id } = useParams();
  return <ApartmentForm method="PATCH" id={id} />;
}
